"use strict";

/**
 * @classdesc
 * Interface für WFS-Provider.
 *
 * @class
 * @extents gc.gis.GCWrappable
 * @memberof gc.gis.map
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.map.GCAbstractWFSProvider = function(options )
{
	gc.gis.GCWrappable.call( this, options );
};
gc.gis.map.GCAbstractWFSProvider.prototype = Object.create( gc.gis.GCWrappable.prototype );

/**
 *
 * @public
 * @method
 */
gc.gis.map.GCAbstractWFSProvider.prototype.loadWFS = gc.gis.abstractMethod;

/**
 * @public
 * @method
 * @param {gc.gis.layer.GCVectorLayer} layer Vektor-Layer-Instanz
 * @return {jQuery} jQuery-Element
 */
gc.gis.map.GCAbstractWFSProvider.prototype.getLegendGraphic = gc.gis.abstractMethod;

/**
 * Liefert für den übergebenen Layer einen GetFeature-Request.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCVectorLayer} layer Vector-Layer-Instanz
 * @return {string}
 */
gc.gis.map.GCAbstractWFSProvider.prototype.getGetFeatureUrl = gc.gis.abstractMethod;
